import {
  AnyAccountId,
  anyAccountId,
  RoomContextId,
  roomContextId,
  RoomId,
  roomId
} from "@common/domain";
import { JsonSchemaValidator } from "@common/json-schema-validator";

export class RoomAccountDeleteEventVO {
  private static validation = JsonSchemaValidator.compile(
    RoomAccountDeleteEventVO.validationSchema()
  );

  constructor(readonly value: RoomAccountDeleteEventVORaw) {
    JsonSchemaValidator.assert(RoomAccountDeleteEventVO.validation, value);
  }

  private static validationSchema() {
    return {
      type: "object",
      required: ["accountId", "roomId", "roomContextId"],
      properties: {
        accountId: anyAccountId,
        roomId,
        roomContextId
      },
      additionalProperties: false
    };
  }
}

interface RoomAccountDeleteEventVORaw {
  accountId: AnyAccountId;
  roomId: RoomId;
  roomContextId: RoomContextId;
}
